import styled from "styled-components";

const InputBlock = styled.div`
  width: 100%;
  position: relative;
  input {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.2px;
    height: 52px;
    background-color: rgba(9, 1, 16, 0.07);
    border: none;
    border-radius: 40px;
    padding: 0 20px;
    caret-color: #802df6;
    transition: 0.2s;
    color: rgba(9, 1, 16, 0.5);
    box-sizing: border-box;
    width: 100%;
    &:focus {
      outline: none;
    }
    &.valid {
      background-color: #dadefe;
    }
    &.invalid {
      background-color: #ffe8e8;
    }
  }
`;

InputBlock.Icon = styled.div`
  position: absolute;
  top: 0;
  right: 22px;
  bottom: 0;
  margin: auto 0;
  height: 24px;
`;

export { InputBlock };
